export const handleApiError = (error, rejectWithValue, backendFieldName = "backendError") => {

  if (!error.response) {
    return rejectWithValue({
      networkError: "Network error. Please check your connection.",
    });
  }

  if (error.response.status === 400) {
    return rejectWithValue({
      [backendFieldName]: error.response.data,
    });
  }

  if (error.response.status === 500) {
    const message = error.response.data?.message;
    return rejectWithValue({
      serverError: message,
    });
  }

  return rejectWithValue({
    unknownError: "An unknown error occurred.",
  });
};
